import { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getTiminglist } from "../../store/apiSlice/GetTimingSlice";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  clearData,
  updateTimingslist,
} from "../../store/apiSlice/UpdateTimingsSlice";
const defaultDaysData = [
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "0",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  },
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "1",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  },
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "2",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  },
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "3",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  },
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "4",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  },
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "5",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  },
  {
    "isFullDayAvialable": 0,
    "date": "",
    "day": "6",
    "timeSlotsAvailablity": [
      "00:00",
      "00:00"
    ],
    "isActive": 1,
    "isDeleted": 0,
    "_id": "",
    "nannyId": "",
    "createdAt": "",
    "isDaySchedule": 0
  }
]

const Dayschange = () => {
  const dispatch = useDispatch();
  const getDays = useSelector(
    (state) => state.rootReducer.getTiminglistReducer.data
  );
  const updateDataReducer = useSelector(
    (state) => state.rootReducer.updateTimingslistReducer.data
  );
  const [newTime, setNewTime] = useState("");
  const [show, setShow] = useState(false);
  const [daysData, setDaysData] = useState();
  const [selectedBox, setSelectedBox] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch(getTiminglist(2));
  }, []);

  useEffect(() => {
    if (!daysData && getDays != null && getDays.status === 1) {
      const data = getDays?.data?.data;
      if (data) {
        const mergedData = defaultDaysData.map((defaultItem) => {
          const matchedItem = data.find((d) => d.day === defaultItem.day);
          return matchedItem || defaultItem;
        });

        setDaysData(mergedData);
      }
    }
  }, [getDays, daysData]);

  const handleToggleActive = (index, val) => {
    setDaysData((daysData) => {
      const updatedDaysData = [...daysData];
      const updatedDay = {
        ...updatedDaysData[index],
        isFullDayAvialable: val ? 1 : 0,
      };
      updatedDaysData[index] = updatedDay;
      return updatedDaysData;
    });
  };

  const handleTime = () => {

    const timeArray =
      daysData[selectedIndex].timeSlotsAvailablity[0].split(",");
    const newValue =
      selectedBox === 0
        ? [newTime + "," + `${timeArray.length > 1 ? timeArray[1] : '00:00'}`]
        : [`${(Array.isArray(timeArray) && timeArray.length > 0 ? timeArray[0] : '00:00')},${newTime}`];

    setDaysData((daysData) => {
      const updatedDaysData = [...daysData];
      const updatedDay = {
        ...updatedDaysData[selectedIndex],
        timeSlotsAvailablity: newValue,
      };
      updatedDaysData[selectedIndex] = updatedDay;
      return updatedDaysData;
    });
    handleClose();
  };

  const selectTime = (index, box) => {
    setSelectedBox(box);
    setSelectedIndex(index);
    handleShow();
  };
  const isValidTimeSlot = (slotArray) => {
    let start, end;
    if (!Array.isArray(slotArray) || slotArray.length === 0) return false;

    if (typeof slotArray[0] === "string" && slotArray.length === 1 && slotArray[0] === '00:00') {
      return true;
    } else if (typeof slotArray[0] === "string" && slotArray.length === 1) {
      const split = slotArray[0].split(",").map(s => s.trim());
      if (split.length !== 2) return false;
      [start, end] = split;
    } else if (slotArray.length === 2) {
      [start, end] = slotArray.map(s => s.trim());
    } else {
      return false;
    }
    if (start === "00:00" && end === "00:00") return true;
    const isTimeFormat = time => /^([01]\d|2[0-3]):[0-5]\d$/.test(time);
    if (!isTimeFormat(start) || !isTimeFormat(end)) return false;
    const toMinutes = time => {
      const [hh, mm] = time.split(":").map(Number);
      return hh * 60 + mm;
    };

    return toMinutes(end) > toMinutes(start);
  };


  const updatedDays = () => {
    const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    for (let index = 0; index < daysData.length; index++) {
      const item = daysData[index];
      const isValid = isValidTimeSlot(item.timeSlotsAvailablity);
      if (!isValid) {
        alert(`${dayName[index]} is invalid`);
        return;
      }
    }
    const payloadData = daysData.map((item) => {
      const { date, day, timeSlotsAvailablity, isFullDayAvialable } = item;
      const transformedTimeSlots = timeSlotsAvailablity
        .map((slot) => {
          const [start, end] = slot.split(",");
          if (start && end) {
            return `${start.trim()}, ${end.trim()}`;
          } else {
            return `00:00`;
          }
        })
        .join(", ");

      if (transformedTimeSlots !== '00:00, 00:00' || isFullDayAvialable !== 0) {
        return {
          date,
          day,
          timeSlotsAvailablity: transformedTimeSlots,
          isFullDayAvialable,
          isDaySchedule: 1
        };
      }
      return null
    });
    let filterPayload = payloadData.filter(item => item !== null);
    const payload = {
      timings: filterPayload
    };
    console.log("111111111111111: ", { payload, payloadData, filterPayload, daysData })
    dispatch(updateTimingslist(payload));
  };

  useEffect(() => {

    if (updateDataReducer != null && updateDataReducer.status === 1) {
      dispatch(clearData());
      dispatch(getTiminglist(2));
    }
  }, [dispatch, updateDataReducer]);

  useEffect(() => {
    return () => {
      dispatch(clearData());
      setDaysData(undefined);
      setNewTime("");
      setShow(false);
      setSelectedBox(null);
      setSelectedIndex(0);
    };
  }, []);

  return (
    <div className="change_day_time">
      <div className="updates">
        <button
          type="button"
          className="update_btn"
          onClick={() => updatedDays()}
        >
          Update
        </button>
      </div>
      <div className="mt-4">
        {/* <h6>Select Desired Day</h6> */}
      </div>
      <Table>
        <thead>
          <tr>
            <th>
              Available All Day
            </th>
            <th>
              Day
            </th>
            <th>Start Time</th>
            <th>End Time</th>
          </tr>
        </thead>
        {daysData != null &&
          daysData.map((item, index) => (
            <tbody>
              <tr>
                <td>
                  <Form>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      checked={item.isFullDayAvialable === 1 ? true : false}
                      onChange={(val) =>
                        handleToggleActive(index, val.target.checked)
                      }
                    />
                  </Form>
                </td>
                <td>
                  {item.day === '0'
                    ? "Sunday"
                    : item.day === '1'
                      ? "Monday"
                      : item.day === '2'
                        ? "Tuesday"
                        : item.day === '3'
                          ? "Wednesday"
                          : item.day === '4'
                            ? "Thursday"
                            : item.day === '5'
                              ? "Friday"
                              : "Saturday"}
                </td>
                <td>
                  <Button onClick={() => selectTime(index, 0)}>
                    {item.timeSlotsAvailablity ? item.timeSlotsAvailablity[0].split(",")[0] : "00:00"}
                  </Button>
                </td>
                <td>
                  <Button onClick={() => selectTime(index, 1)}>
                    {item.timeSlotsAvailablity && item.timeSlotsAvailablity[0].split(",")[1] ? item.timeSlotsAvailablity[0].split(",")[1] : "00:00"}
                  </Button>
                </td>
              </tr>
            </tbody>
          ))}
      </Table>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal_address change_time"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Time</Modal.Title>
        </Modal.Header>
        <Modal.Body className="time_change_input">
          <div className="time_select">
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={"en"}
            >
              <TimePicker
                ampm={false}
                onChange={(e) => {
                  const hour =
                    e.hour().toString().length === 1
                      ? "0" + e.hour()
                      : e.hour();
                  const minute =
                    e.minute().toString().length === 1
                      ? "0" + e.minute()
                      : e.minute();

                  setNewTime(hour + ":" + minute);
                }}
              />
            </LocalizationProvider>
          </div>

          <button onClick={() => handleTime()} className="apply_btn">
            Apply
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Dayschange;
